import { types } from "../action-types";

const initialState = {
  loading: false,
  resp: [],
  success: false,
  error: false,
};

const rejectTimeSheetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REJECT_TIMESHEET_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case types.REJECT_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        resp: action.payload,
        error: false,
      };
    case types.REJECT_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    case types.REJECT_TIME_OFF_REQUESTED:
      return {
        ...state,
        rejectTimeOffLoading: true,
        success: false,
      };
    case types.REJECT_TIME_OFF_SUCCESS:
      return {
        ...state,
        rejectTimeOffLoading: false,
        success: true,
        resp: action.payload,
        error: false,
      };
    case types.REJECT_TIME_OFF_FAILURE:
      return {
        ...state,
        rejectTimeOffLoading: false,
        success: false,
        error: true,
      };
    default:
      return state;
  }
};
export default rejectTimeSheetReducer;
